import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstfid: [],
		fid: {
            fidcclasst: "",
            fidcst: "",
            fiddescric: "",
            fidredibs: 0,
            fidredcbs: 0,
        },
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		isLiquidation: false,
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getfid(state) {
			let fid = { ...state.fid }
			return fid
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, fid) {
			state.fid = fid
			if (fid) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fid = null
		},
		setParamsDataTable(state, payload) {
			state.lstfid = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setfid(state, fid) {
			state.fid = fid
		},
		setLstfid(state, lstfid) {
			state.lstfid = lstfid
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Fiscal/FiscalTaxClass/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstfid", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, { fidcclasst, fidcst }) {
            let fid = null
			await this._vm.$axios
				.get(`/Fiscal/FiscalTaxClass/Find/${fidcclasst}/${fidcst}`)
				.then(response => {
					fid = Utils.ValidateAxiosResponse(response.data)
					commit("set", fid)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
                    return null
				})
            return fid
		},	
		async save({ getters, dispatch, state }, fid) {
			if (getters.getUpdate) {
				return await dispatch("update", fid)
			}
			return await dispatch("insert", fid)
			
		},
		async insert({ commit, getters, dispatch }, fid) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Fiscal/FiscalTaxClass/Insert", fid)
				.then(response => {
					let validated = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", validated)
					commit("setfid", null)
					return validated
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }, fid) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Fiscal/FiscalTaxClass/Update", fid)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }, fidcclasst, fidcst) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Fiscal/FiscalTaxClass/Delete/${fidcclasst}/${fidcst}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
        async findByCst({ commit, dispatch }, {fidcst}) {
            if(!fidcst)
                fidcst = ""
			return await this._vm.$axios.get(`/Fiscal/FiscalTaxClass/FindByCst?fidcst=${fidcst}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},	
		async findCclassTribAndDescricByCst({ commit, dispatch }, {fidcst}) {
            if(!fidcst)
                fidcst = ""
			return await this._vm.$axios.get(`/Fiscal/FiscalTaxClass/FindCclassTribAndDescricByCst?fidcst=${fidcst}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},	
	},
}
